import { render, staticRenderFns } from "./PaymentPage.vue?vue&type=template&id=500c0e9c&scoped=true&"
import script from "./PaymentPage.vue?vue&type=script&lang=js&"
export * from "./PaymentPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "500c0e9c",
  null
  
)

export default component.exports